import { IconButton, Tooltip } from "@mui/material";
import { useContext } from "react";
import Iconify from "src/components/Iconify";
import TableSelectedAction from "src/components/table/TableSelectedAction";

import Context from "../context";
import { UnknownTransaction } from "../Type";
import ContextControlTable from "./contextTable";

// ----------------------------------------------------------------------

type Props = {
	data: UnknownTransaction[];
};

export default function TableSelectedHeader({ data }: Props) {
	const { selected, onSelectAllRows } = useContext(ContextControlTable);
	const { actions } = useContext(Context);

	return (
		<TableSelectedAction
			numSelected={selected.length}
			rowCount={data?.length ?? 0}
			onSelectAllRows={(checked) => onSelectAllRows(checked, data?.map((row) => row.description))}
			action={
				<Tooltip title='Delete'>
					<IconButton color='primary' onClick={() => actions.showDeleteDialog(selected)}>
						<Iconify icon='eva:trash-2-outline' />
					</IconButton>
				</Tooltip>
			}
		/>
	);
}
